/**
 * Temporary visibility switches. Nothing here deletes anything: the routes, pages, tools, content
 * and SEO stay exactly as they are, so flipping a flag back to true restores the links.
 */

// Hides the promotional Planning Tools entry points — header navigation, the Start Planning
// button, the homepage tile and section, the footer column and the 404 link. Contextual links
// inside hubs and guides, where a tool answers the question being read, are deliberately kept.
export const PLANNING_TOOLS_VISIBLE = false;
